import { MailType } from './mail-type';

export class MailboxQuery {
  page: number = 1;
  limit: number;
  type: MailType;
  important?: boolean;
}



// WEBPACK FOOTER //
// ./app/states/mailbox/shared/mailbox-query.ts